import { useState } from "react";

import classes from "./HeaterSelectionAssistant.module.less";
import { FormHS } from "./components/FormHS";
import { ResultHS } from "./components/ResultHS";
import { BannerHS } from "~/HeaterSelectionAssistant/components/BannerHS";
import { useTranslation } from "react-i18next";
import { useOnMount } from "~/common/hooks/useOnMount";
import { loadCartAmounts } from "~/AddToCart/redux/cartAmounts/actions";
import { useDispatch } from "react-redux";
import {
  PurchasePlaceProvider,
  PurchaseTypeProvider,
} from "~/feature/Analytics/ga/recommendations/RecommendationContexts";

export interface ResultsHeaterProps {
  imageUrl: string;
  mass: number;
  name: string;
  url: string;
}

export function HeaterSelectionAssistant() {
  const { t } = useTranslation();

  const [result, setResult] = useState<ResultsHeaterProps[] | null>(null);

  function handleChange(newValue: ResultsHeaterProps[] | null) {
    setResult(newValue);
  }

  const dispatch = useDispatch();
  useOnMount(() => {
    dispatch(loadCartAmounts());
  });

  return (
    <div className={classes.container} tracking-aux-container="heater_selection_assistant">
      <div className={classes.pageTitle}>{t("heaterSelectionAssistant.pageTitle")}</div>
      <div className={classes.pageSubTitle}>{t("heaterSelectionAssistant.pageSubTitle")}</div>

      <FormHS handleChange={handleChange} />

      {result && (
        <div className={classes.tableResult}>
          <ResultHS data={result} />
        </div>
      )}

      <div className={classes.bannerMsg} tracking-aux-banner="heater_selection_assistant_explore_now">
        <BannerHS />
      </div>
    </div>
  );
}

export function createHeaterSelectionAssistantComponent() {
  return (
    <PurchasePlaceProvider value={"HTSA"}>
      <PurchaseTypeProvider value={"htsa"}>
        <HeaterSelectionAssistant />
      </PurchaseTypeProvider>
    </PurchasePlaceProvider>
  );
}
